import { render } from 'solid-js/web';
import { SongBar } from './SongBar';

export interface SongBarCallbacks {
  onSearch: (query: string) => void;
  onSearchFocus: () => void;
  onSearchBlur: () => void;
  onQuantizationCycle: (value: string) => void;
  onGameReset: () => void;
  onCalibrateStart: () => void;
  onCalibrateConfirm: () => void;
  onCalibrateCancel: () => void;
  onMaxKeysChange: (n: number) => void;
  initialMaxKeys?: number;
}

export function mountSongBar(mountEl: HTMLElement, callbacks: SongBarCallbacks): void {
  render(
    () => (
      <SongBar
        onSearch={callbacks.onSearch}
        onSearchFocus={callbacks.onSearchFocus}
        onSearchBlur={callbacks.onSearchBlur}
        onQuantizationCycle={callbacks.onQuantizationCycle}
        onGameReset={callbacks.onGameReset}
        onCalibrateStart={callbacks.onCalibrateStart}
        onCalibrateConfirm={callbacks.onCalibrateConfirm}
        onCalibrateCancel={callbacks.onCalibrateCancel}
        onMaxKeysChange={callbacks.onMaxKeysChange}
        initialMaxKeys={callbacks.initialMaxKeys}
      />
    ),
    mountEl,
  );
}
